import { mountComponent } from './adyen_checkout_mounter';

interface IMountSecuredFieldsArgs {
  domSelector: string;
  onFieldValid: Function;
  onBrand?: Function;
  onFocus: Function;
  onError: Function;
  onConfigSuccess?: Function;
  locale: string;
}

export function mountAdyenSecuredFields(args: IMountSecuredFieldsArgs): void {
  mountComponent({
    domSelector: args.domSelector,
    type: 'securedfields',
    locale: args.locale,
    props: {
      onFieldValid: args.onFieldValid,
      onBrand: args.onBrand,
      onFocus: args.onFocus,
      onError: args.onError,
      onConfigSuccess: args.onConfigSuccess,
      styles: {
        base: {
          background: 'transparent',
          color: '#212121',
          fontSize: '16px',
          fontSmoothing: 'auto',
          fontFamily: 'Consolas, "Andale Mono WT", "Andale Mono", "Lucida Console", "Lucida Sans Typewriter", "DejaVu Sans Mono", "Bitstream Vera Sans Mono", "Liberation Mono", "Nimbus Mono L", Monaco, "Courier New", Courier, monospace',
          fontWeight: '400',
          lineHeight: '1.4',
          padding: '6px 8px',
        },
      },
    },
  });
}

// https://docs.adyen.com/checkout/api-integration/build-your-own-payment-form/secured-fields-callbacks/#onfieldvalid
export interface IOnFieldValidData {
  blob?: string;
  valid: boolean;
  encryptedFieldName: string;
  fieldType: string;
  endDigits?: string;
}

export interface IOnFocusData {
  focus: boolean;
  fieldType: string;
}

export interface IOnErrorData {
  error: string;
  fieldType: string;
}

export interface ITokenizedFieldState {
  hasFocus: boolean;
  error: string;
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/credit_cards/adyen_secured_fields.ts